export default __webpack_public_path__ + "static/media/facebook.6d5387f8.webp";